<template>
    <div class="page light">

        <Top></Top>

        <div class="hidden-lg hidden-xl navbar navbar-style-1">
            <div class="navbar-inner">
                <a v-on:click="$root.back();" class="link back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.439312 13.0606L5.75391 18.3752C6.04683 18.6682 6.43069 18.8146 6.81459 18.8146C7.1985 18.8146 7.58236 18.6682 7.87528 18.3752C8.46103 17.7894 8.46103 16.8397 7.87528 16.2539L5.12133 13.5H22.5C23.3284 13.5 24 12.8284 24 12C24 11.1716 23.3284 10.5 22.5 10.5H5.12133L7.87528 7.7461C8.46103 7.1603 8.46103 6.21057 7.87528 5.62477C7.28944 5.03898 6.33975 5.03898 5.75391 5.62477L0.439312 10.9394C-0.146437 11.5251 -0.146437 12.4749 0.439312 13.0606Z" fill="black"></path>
                    </svg>
                </a>
                <div class="title" style="">{{form.cod ? 'Editar' : 'Adicionar'}} serviço</div>
                <div class="right">
                    <a  class="link hidden">
                        <i class="las la-shopping-cart"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="page-content content-area pt-60 bottom-sp60">
              
            <div class="container hidden-xs hidden-md">
                <h2>{{form.cod ? 'Editar' : 'Adicionar'}} serviço</h2>
            </div>

            <div class="">
                <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                    <div class="list" style="margin-top: 16px">
                        <ul class="row">                        
                                                           
                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Tipo do serviço (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <select class="form-control" v-model="form.metodo">
                                            <option value="" disabled selected hidden>Selecione..</option>
                                            <option value="consulta">Consulta</option>
                                            <option value="procedimento">Procedimento</option>
                                        </select>
                                    </div>
                                </div>
                            </li>

                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Nome (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="text" placeholder="Escreva o nome do serviço.." v-model="form.nome" class="form-control"/>
                                    </div>
                                </div>
                            </li>       

                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Preço (R$) (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <money v-model="form.valor" v-bind="$root.config.money" class="form-control" placeholder="__"></money>
                                    </div>
                                </div>
                            </li>

                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Duração - em minutos (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="number" placeholder="__" v-model="form.duracao" class="form-control"/>
                                    </div>
                                </div>
                            </li>          

                            <li class="item-content item-input col-100">
                                <div class="item-inner">
                                    <div class="item-title item-label">Intervalo - em minutos (obrigatório)</div>
                                    <div class="item-input-wrap">
                                        <input type="number" placeholder="__" v-model="form.intervalo" class="form-control"/>
                                    </div>
                                </div>
                            </li>                                                                                                             

                            <li class="col-100">
                                <label class="item-checkbox item-checkbox-icon-start item-content">
                                    <input type="checkbox" name="checkbox-visivel" v-model="form.visivel" true-value="1" false-value="0">
                                    <i class="icon icon-checkbox"></i>
                                    <div class="item-inner">
                                        <div class="item-title">Serviço ativo</div>
                                    </div>
                                </label>
                            </li>  
                        </ul>

                        <div class="row mt-20">

                        </div>                          
                    </div>

                    <div class="block">
                        <button type="submit" class="link external button-large button button-fill">
                            <i class="las la-save"></i>
                            Salvar
                        </button>
                    </div>
                </form>

            </div>

        </div>
        
        <!-- <Toolbar></Toolbar> -->
    </div>
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'GerenciarServicos',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        },
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },      
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "categorias": {
                "itens":            []
            },          
            "form": {
                "agendaCod":        "",
                "nome":             "",
                "metodo":           "",
                "tipo":             "servico",
                "duracao":          "60",
                "intervalo":        "30",
                "visivel":          1,
                "valor":            ""
            }            
        }
    },
    watch: {
        "form.metodo": function(val) {
            var self = this;
            console.log("watch form.metodo >>", val);

            if (val == "consulta" && !self.form.nome) {
                self.form.nome      = "Consulta";
                self.$forceUpdate();
            }
        }
    },
    methods: {                  
        submit: function(e) {
            
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            axios[a]("api/catalogo.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                // alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        if (self.$route.name == "EditarServicos") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {

            if (!self.$route.query.agendaCod) {
                self.$root.back();
                return false;
            } else {
                self.form.agendaCod = self.$route.query.agendaCod;
            }
            
            loading.hide();
        }
    },
    activated: function() {
        var self = this;
    },       
    mounted: function() {
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
   
    .tag-list {
        margin-bottom: 0px !important;
        margin-top: 0px;
    }

    .item-title {
        margin-bottom: 0px !important;
        line-height: 130%;
        font-weight: 500;
        font-size: 16px;
    }
    .chip-label {
        font-weight: bold;
        font-size: 12px !important;
    }
    .chip {
        line-height: 18px !important;
        height: auto !important;
        min-height: 18px !important;
        /*padding-bottom: 0px;*/
        /*padding-top: 0px;*/
        margin-top: -4px;
        margin-left: -2px;
        margin-bottom: 5px;
    }
    .dz-media {
        margin-bottom: 5px !important;
    }
    .tabbar.tab-style-2 .tab-link:after {
        display: none !important;
    }

    .banner {
        background: var(--f7-theme-color);
        padding: 20px;
        margin-bottom: 30px;
    }

    .banner h4 {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }

    .banner p {
        color: #fff;
        line-height: 130%;
        padding: 0px !important;
        margin: 0px !important;
    }    

    .img-perfil {
        width: 50px;
        height: 50px;
        background-size: cover;
        background-position: center;
        border: 1px solid #ddd;
        border-radius: 6px;
        display: inline-block;
    }    

    .col-50-grid {
      margin: 0;
      display: grid;
      grid-template-rows: 1fr auto;
      margin-bottom: 10px;
      break-inside: avoid;    
    }

    .row-grid {
      column-count: 2;
      column-gap: 20px;
    }
  
    .item-bx.item-grid {
        margin-bottom: 15px;
    }         

    .categories-bx.active {
        background: #f8b832 !important;
        color: #222 !important;
    }

    .cart-list-area {
        padding-left: 0;
        padding-right: 0;
    }

    .cart-list {
        overflow: hidden;
        margin: 0;
    }

    .cart-item {
        background-color: #fff;
        overflow: unset;
        margin: 6px 0;
        border-bottom: 1px solid #ddd;
        padding-bottom: 0px;        
    }        
   
    .cart-item .item-inner {
        background-color: #fff;
        padding: 12px 30px;
    }   

    .cart-item .item-media {
        min-width: 95px !important;
        width: 95px;
        position: relative;
        padding: 0;
        border-radius: 16px;
        overflow: hidden;
        margin-right: 20px;
        height: 115px;
        align-items: flex-start;
        height: 105px;
    }

    .cart-item .item-media img {
        width: 100%;
    }

    .cart-item .item-media .item-price {
        background-color: var(--f7-theme-color);
        color: #fff;
        position: absolute;
        bottom: 0;
        margin: 0;
        width: 100%;
        left: 0;
        text-align: center;
        font-weight: 500;
        font-size: 16px;
        padding: 5px;
        border-radius: 16px;
        box-sizing: border-box;
    }

    .cart-item .item-info {
        width: 100%;
        justify-content: space-between;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 5px 0;
        box-sizing: border-box;
    }

    .cart-item .item-foot {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .cart-item .item-foot .item-total {
        margin: 0;
        font-weight: 500;
        font-size: 16px;
    }                        

    .cart-item .item-content {
        padding-left: 0;
        transition: all 0.5s;
    }

    .cart-item .item-head .category {
        margin: 0;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.6);
    }

    .cart-item .item-title a {
        color: #000;
        word-break: break-word;
        white-space: break-spaces;
        text-overflow: ellipsis;
        display: block;
        line-height: 130%;
    }

    .cart-item .item-title {
        font-weight: 500;
        margin: 0 0 10px;
    }        

    .cart-item .item-media div {
        width: 100%;
        height: 100%;
        background-size: cover !important;
        background-position: center;
        background: #efefef;
        border-radius: 6px;
    }

    .button-round {
        border-radius: 20px !important;
    }

    .badge-large {
        padding: 15px;
    }

    .badge-outline:not(.color-green) {
        background: transparent !important;
        border: 2px solid #064972 !important;
        color: #064972;
    }

    .badge.color-secondary {
        border: 2px solid #064972 !important;
    }

    .badge.color-primary {
        border: 2px solid #0f8cd5 !important;
    }    

    .badge.color-green:not(.badge-outline) {
        border: 2px solid #4cd964 !important;
    }

    .badge-outline.color-green {
        background: transparent !important;
        border: 2px solid #4cd964 !important;
        color: #4cd964;
    }    

    .container {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }

    .button-fill.color-grey {
        background: #ddd !important;
        color: #666 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/GerenciarServicos.vue